var map = {
	"./BOOST.svg": 2408,
	"./GRAB.svg": 2409,
	"./MBB.svg": 2410,
	"./TNG.svg": 2411,
	"./direpay.svg": 2412,
	"./doitnow.svg": 2413,
	"./duitnow.svg": 2414,
	"./fpay.svg": 2415,
	"./fpay2.svg": 2416,
	"./fpx.svg": 2417,
	"./online_banking.svg": 2418,
	"./rapidpays.svg": 2419,
	"./secret_pay.svg": 2420,
	"./secret_pay_offline.svg": 2421,
	"./secret_pay_pro.svg": 2422,
	"./secret_pay_pro_b.svg": 2423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;